import React from 'react';
import cls from 'classnames';
import makeBodyText from '../../utils/makeText';
import styles from './index.module.scss';
import Spinner from '../../components/Spinner';
const List = ({ selectedItem, itemsList, onElemClick, textSize, matchValue, isSearchStarted, CTAOption = null, isLoading }) => {
    const renderCTAOption = () => {
        if (!CTAOption) {
            return null;
        }
        const { id, label, onClick } = CTAOption;
        return (React.createElement("button", { id: id, key: 'ctaKey', type: 'button', "data-label": label, onMouseDown: onClick, className: `${styles.listItem} ${styles.ctaItem}` },
            React.createElement("span", { className: `${styles.text} ${styles.ctaText}` }, label)));
    };
    const _renderItems = () => {
        const isWholeListAppearAllowed = selectedItem && !isSearchStarted;
        if (!itemsList || itemsList.length === 0) {
            return null;
        }
        return itemsList.map(({ id, label, isDisabled }) => {
            const regExp = new RegExp(`^${matchValue}`, 'i');
            const isSelected = selectedItem === id;
            const isElemNotMatched = matchValue && !label.match(regExp);
            if (!isWholeListAppearAllowed && isElemNotMatched) {
                return null;
            }
            return (React.createElement("button", { id: id, key: id, type: 'button', "data-label": label, onMouseDown: onElemClick, disabled: isDisabled, className: `${styles.listItem} ${isSelected ? styles.selected : ''}` },
                React.createElement("span", { className: `${styles.text} ${makeBodyText(textSize || 'L')}` }, label)));
        });
    };
    const itemsToRender = _renderItems();
    const isEmptyList = () => itemsToRender && itemsToRender.every((elem) => elem === null);
    return (React.createElement("div", { className: cls(styles.listPanelWrap, {
            [styles.withoutScroll]: isEmptyList()
        }) },
        React.createElement("div", { className: cls(styles.innerWrap, {
                [styles.loading]: isLoading
            }) }, isLoading ? React.createElement(Spinner, { color: 'blue' }) : itemsToRender),
        !isLoading && renderCTAOption()));
};
export default List;
